import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RESET_GERENCIADOR_DATAPOINTS, SET_GERENCIADOR_DATAPOINTS } from '../../../../reducers/gerenciadorPrecos/datapoints';
import { SET_GERENCIADOR_TOTAL_ELEMENTS, selectorTotalElements } from '../../../../reducers/gerenciadorPrecos/totalElements';
import { checkIfIsLoading } from '../../../../utils';
import useAppyPricesButton from '../Components/AppyPricesButton/useAppyPricesButton';
import { GetDatapointsRevisao, getDatapointsRevisao } from '../services';
import useGerenciadorTable from '../useGerenciadorTable';
import { usePriceManagerDatapointsModel } from './usePriceManagerDatapointsModel';

export const useGerenciadorPrecos = () => {
  const dispatch = useDispatch();

  const totalElements = useSelector(selectorTotalElements);

  const table = useGerenciadorTable();

  const { sort } = table;

  const MODEL_GET_DATAPOINTS = usePriceManagerDatapointsModel();

  const { isLoading: isApplyingPrices } = useAppyPricesButton();

  const getItensRevisao = useCallback(async () => {
    dispatch(RESET_GERENCIADOR_DATAPOINTS());
    const response = getDatapointsRevisao(MODEL_GET_DATAPOINTS);
    return response;
  }, [MODEL_GET_DATAPOINTS, dispatch]);

  const getItensRevisaoSuccess = useCallback(
    (data: GetDatapointsRevisao.Response) => {
      dispatch(SET_GERENCIADOR_DATAPOINTS(data.content));
      dispatch(SET_GERENCIADOR_TOTAL_ELEMENTS(data.totalElements));
    },
    [dispatch],
  );

  const { fetchStatus } = useQuery({
    queryKey: ['ipa.gerenciador.datapoints', MODEL_GET_DATAPOINTS],
    queryFn: getItensRevisao,
    onSuccess: getItensRevisaoSuccess,
    keepPreviousData: true,
    enabled: !isApplyingPrices,
  });

  return {
    sort,
    table: {
      ...table,
      loading: checkIfIsLoading(fetchStatus),
    },
    totalElements,
    MODEL_GET_DATAPOINTS,
  } as const;
};
